import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'

import { collection, doc } from 'firebase/firestore'

import { ChallengeFieldsParams } from '../components/forms/ChallengeForm/challengeFields'
import { useStorage } from '../context'
import { firestore } from '../firebase/firebaseConfig'
import { Challenge, ChallengeVisibility, FormFields } from '../types'

// TODO: MAKE IT REUSABLE FOR ALL THE FORMS
export const useChaFormState = (
  state: Challenge,
  setState: Dispatch<SetStateAction<Challenge>>,
  formFields: ({
    state,
    hashtagInput,
    setHashtagInput,
  }: ChallengeFieldsParams) => FormFields[],
) => {
  const [hashtagInput, setHashtagInput] = useState('')
  const { uploadImage } = useStorage()

  const updateState = (
    key: string,
    value: number | string | string[] | null,
  ) => {
    setState((prev) => ({ ...prev, [key]: value }))
  }

  useEffect(() => {
    if (!state.id) {
      const newDocId = doc(collection(firestore, 'challenges')).id

      updateState('id', newDocId)
    }
  }, [state.id])

  const updateInput = useCallback(
    (
      e: ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >,
    ) => {
      const { name, value } = e.target

      if (name === 'visibility') {
        setState((prev) => ({
          ...prev,
          [name]: value === ChallengeVisibility.VISIBLE ? true : false,
        }))
      } else {
        setState((prev) => ({ ...prev, [name]: value }))
      }
    },
    [],
  )

  // const updateDate = (key: string, date: Dayjs) => {
  //   const _date = dayjs(date).format('DD-MM-YYYY')

  //   setState((prev) => ({ ...prev, [key]: _date }))
  // }

  //   const updateTags = useCallback(
  //     (key: keyof ChallengeFormValues, value: string) => {
  //       setState((prev) => {
  //         const currentArray = prev[key] as string[]

  //         return currentArray.includes(value)
  //           ? prev
  //           : {
  //               ...prev,
  //               [key]: [...currentArray, value],
  //             }
  //       })
  //     },
  //     [],
  //   )

  const handleHashtagKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      const value = hashtagInput.trim().replace(/^#/, '')
      setState((prev) => {
        return prev.hashtags.includes(value)
          ? prev
          : {
              ...prev,
              hashtags: [...prev.hashtags, value],
            }
      })
      setHashtagInput('')
    }
  }

  const removeHashtag = (tag: string) => {
    const filterHashtags = state.hashtags.filter((h) => h !== tag)
    setState((prev) => ({ ...prev, hashtags: filterHashtags }))
  }

  // const handleCoverUpload = (e: ChangeEvent<HTMLInputElement>) => {
  //   // TODO agregar la funcion de cargado a firebase
  //   const file = e.target.files?.[0]
  //   if (!file) return
  //   const url = URL.createObjectURL(file)
  //   setState((prev) => ({ ...prev, image: url }))
  // }

  const handleCoverUpload = (refId: string, blob: Blob) => {
    const imageURL = uploadImage(refId, blob, 'challenges')
    return imageURL
  }

  const fields = useMemo(
    () => formFields({ state, hashtagInput, setHashtagInput }),
    [state, hashtagInput, setHashtagInput],
  )

  const handleParticipants = (userId: string) => {
    setState((prev) => {
      const participants = prev.participants ?? []
      const exists = participants.includes(userId)
      const next = exists
        ? participants.filter((p) => p !== userId)
        : [...participants, userId]

      return {
        ...prev,
        participants: next,
      }
    })
  }

  return {
    // state,
    fields,
    updateInput,
    handleHashtagKeyDown,
    removeHashtag,
    handleCoverUpload,
    updateState,
    handleParticipants,
    // updateDate,
  }
}
